<template>
  <ChipBadge :color="colorByState" rounded :data-testid="`status-badge-${review.currentStatus}`">
    {{ t(`Reviews.agency.reviews.table.statusLabel.${labelKey}`, t('Reviews.agency.reviews.table.statusLabel.unknown')) }}
  </ChipBadge>
</template>

<script setup lang="ts">
import { ChipBadge } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { UniversalReview } from '@/components/ReviewsAgenciesManagements/Reviews/types'
import {
  universalReviewStatusColor,
  universalReviewStatusLabelKey,
} from '@/components/ReviewsAgenciesManagements/Reviews/universalReviewStatus'

const props = defineProps<{ review: UniversalReview }>()

const { t } = useI18n()

const labelKey = computed(() => universalReviewStatusLabelKey(props.review.currentStatus))
const colorByState = computed(() => universalReviewStatusColor(props.review.currentStatus))
</script>
